
import React from 'react';
import { motion } from 'framer-motion';

const Features: React.FC = () => {
  const features = [
    {
      title: "Acero Inoxidable 304",
      description: "Máxima calidad y resistencia contra la corrosión y el desgaste diario.",
      icon: "fa-solid fa-shield-halved"
    },
    {
      title: "Vidrio Templado",
      description: "Tablero superior de alta seguridad resistente a impactos y cambios térmicos.",
      icon: "fa-solid fa-layer-group"
    },
    {
      title: "Base de Espejo",
      description: "Nivel inferior con acabado espejo que aporta profundidad y lujo al diseño.",
      icon: "fa-regular fa-square"
    },
    {
      title: "Dimensiones Ideales",
      description: "Medidas exactas de 80cm x 45cm x 50cm, perfectas para cualquier sala moderna.",
      icon: "fa-solid fa-ruler-combined"
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5 } }
  };

  return (
    <section id="caracteristicas" className="py-24 bg-slate-50 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div 
          className="text-center mb-16"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <h2 className="text-3xl font-bold text-slate-900 mb-4 tracking-tight uppercase tracking-widest">Características Premium</h2>
          <div className="h-1 w-16 bg-slate-900 mx-auto rounded-full"></div>
        </motion.div>

        <motion.div 
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
        >
          {features.map((feature, idx) => (
            <motion.div 
              key={idx} 
              className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-xl transition-all border border-slate-100 text-center lg:text-left group"
              variants={itemVariants}
              whileHover={{ y: -10 }}
            >
              <div className="w-14 h-14 bg-slate-900 text-white rounded-xl flex items-center justify-center mb-6 mx-auto lg:mx-0 group-hover:bg-slate-700 transition-colors">
                <i className={`${feature.icon} text-2xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-2">{feature.title}</h3>
              <p className="text-slate-600 text-sm leading-relaxed">{feature.description}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Features;
